import { simpleSet } from '@r/reducers/utils';

const setCalculationModeCountertopValue = simpleSet as
  redux.reducers.calculationMode.settings.materials.countertop.value;

export const value = setCalculationModeCountertopValue(
  'SET_CALCULATION_MODE_COUNTERTOP_VALUE',
  { value: '', label: '' }
);
